
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, Search, Phone } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white">
      <div className="text-center max-w-2xl mx-auto px-4">
        <h1 className="text-6xl font-bold mb-4 text-[#8932c8]">404</h1>
        <h2 className="text-2xl font-semibold mb-4 text-gray-900">Page Not Found</h2>
        <p className="text-lg text-gray-600 mb-8">
          The page you're looking for doesn't exist or has been moved. 
          Don't worry, let's get you back on track with our cybersecurity solutions.
        </p>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          <Link to="/">
            <Button className="w-full bg-[#8932c8] hover:bg-[#7a2cb3] text-white flex items-center gap-2">
              <Home size={16} />
              Home
            </Button>
          </Link>
          <Link to="/products/spharakaxdr">
            <Button variant="outline" className="w-full border-[#8932c8] text-[#8932c8] hover:bg-[#8932c8]/5 flex items-center gap-2">
              <Search size={16} />
              Products
            </Button>
          </Link>
          <Link to="/solutions">
            <Button variant="outline" className="w-full border-[#8932c8] text-[#8932c8] hover:bg-[#8932c8]/5 flex items-center gap-2">
              <ArrowLeft size={16} />
              Solutions
            </Button>
          </Link>
          <Link to="/contact">
            <Button variant="outline" className="w-full border-[#8932c8] text-[#8932c8] hover:bg-[#8932c8]/5 flex items-center gap-2">
              <Phone size={16} />
              Contact
            </Button>
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 border border-gray-200">
          <h3 className="text-xl font-semibold mb-4 text-gray-900">Popular Pages</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
            <div>
              <h4 className="font-medium text-gray-900 mb-2">Products & Solutions</h4>
              <ul className="space-y-1 text-sm text-gray-600">
                <li><Link to="/products/spharakaxdr" className="hover:text-[#8932c8] transition-colors">Spharaka XDR Platform</Link></li>
                <li><Link to="/products/auraxp" className="hover:text-[#8932c8] transition-colors">AuraXP AI Technology</Link></li>
                <li><Link to="/solutions/enterprise" className="hover:text-[#8932c8] transition-colors">Enterprise Solutions</Link></li>
                <li><Link to="/solutions/government" className="hover:text-[#8932c8] transition-colors">Government Security</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-gray-900 mb-2">Resources & Support</h4>
              <ul className="space-y-1 text-sm text-gray-600">
                <li><Link to="/case-studies" className="hover:text-[#8932c8] transition-colors">Case Studies</Link></li>
                <li><Link to="/about" className="hover:text-[#8932c8] transition-colors">About Spharaka</Link></li>
                <li><Link to="/contact" className="hover:text-[#8932c8] transition-colors">Get Support</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-500 mt-6">
          Need immediate assistance with cybersecurity threats? 
          <Link to="/contact" className="text-[#8932c8] hover:underline ml-1">Contact our security experts</Link>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
